import {guestTypes} from "./type";
import {BaseAction} from "../../actions/base";

const types = guestTypes;

const path = `iot/guest`;

const base = new BaseAction(types);

export const getGuestDatas = () => (dispatch) => {
    return base.getDatas(path, dispatch);
};

export const getDeletedGuestDatas = () => (dispatch) => {
    return base.getDatas(`${path}/deleted`, dispatch);
};

export const getGuestData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}`, dispatch);
};

export const getDeletedGuestData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}/deleted`, dispatch);
};

export const addGuestData = (newData) => (dispatch) => {
    return base.addData(path, dispatch, newData);
};

export const editGuestData = (id, newData) => (dispatch) => {
    return base.editData(`${path}/${id}`, dispatch, newData);
};

export const deleteGuestData = (id) => (dispatch) => {
    return base.deleteData(`${path}/${id}`, dispatch, id);
};

export const restoreGuestData = (id) => (dispatch) => {
    return base.restoreData(`${path}/${id}/restore`, dispatch, id);
};

export const hardDeleteGuestData = (id) => (dispatch) => {
    return base.hardDeleteData(`${path}/${id}/confirmdelete`, dispatch, id);
};
